'use strict';
// LIBS
import 'pixi.js'
import { TweenMax } from 'gsap';

// MODULES
import OuterHeaven from './base/outerheaven.js';
import BrowserDetection from './base/detection.js';
import Env from './base/env.js';
import Toolbox from './base/toolbox.js';
import Channels from './base/channels.js';
import MainTransition from './transition/TransitionMain'
import Home from './view/home.js';
import Works from './view/works.js';
import Single from './view/single.js';
import About from './view/about.js';
import Contact from './view/contact.js';
import UI from './view/ui.js';


document.addEventListener('DOMContentLoaded', function()
{
    PIXI.utils.skipHello();
    // Starter
    Env.framework.toolbox = new Toolbox();
    new BrowserDetection();
    window.addEventListener('resize',function() {
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(function(){
            Channels.emit('window::smartresize')
        }, 200);
    });

    // Views
    Env.framework.UI = new UI()
    Env.framework.MainTransition = new MainTransition()
    Home.init()
    Works.init()
    Single.init()
    About.init()
    Contact.init()

    // Signature
    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
        var args = ['\n %c with <3 by @jcsuzanne \u2730 http://www.jcsuzanne.com/ \n\n','background: #ffcc33; padding:5px 0;color: #333333;'];
        window.console.log.apply(console, args);
        var argsD = ['\n %c design by @indexstudio \u2730 https://index.studio/ \n\n','background: #000000; padding:5px 0;color: #ffffff;'];
        window.console.log.apply(console, argsD);
    } else if (window.console) {
        window.console.log('@jcsuzanne - http://www.jcsuzanne.com/');
    }

    // Start Barba
    new OuterHeaven();

    // PWA
    if(config.env === "production") {
        navigator.serviceWorker.controller?console.log("[PWA Builder] active service worker found, no need to register"):navigator.serviceWorker.register(config.pathRoot+"pwa.js",{scope:config.pathRoot}).then(function(e){console.log("Service worker has been registered for scope:"+e.scope)});
    }
});

